import { Box, MenuItem, Typography } from '@mui/material'
import type { ObjectTypesService } from '@/object-types/services/ObjectTypesService'
import type { NewItemButtonController } from './NewItemButtonController'
import { useDiRef } from '@/common/react/di-hooks'
import { useBehaviorObservable } from '@/common/react/observable-hooks'
import type { ObjectTypeModel } from '@/core/gql/gql-models-override.ts'

export interface CollectionsNewPopoverItemsProps {
  setPopoverResult: (result: ObjectTypeModel) => void
  controller: NewItemButtonController
}

const config = {
  marginLeft: 2,
  minWidth: '200px',
}

export function NewItemTypePopoverItems({
  setPopoverResult,
  controller,
}: CollectionsNewPopoverItemsProps) {
  const typesService = useDiRef<ObjectTypesService>('ObjectTypesService')
  const types = useBehaviorObservable(typesService.selectedSpaceTypes$)

  if (!types) {
    return
  }
  return (
    <>
      <Box sx={{ minWidth: config.minWidth }}>
        <Typography
          sx={{
            width: 'fit-content',
            fontSize: '0.875rem',
            lineHeight: 1,
            mx: config.marginLeft,
            mt: 1.25,
            mb: 1.25,
            color: (theme) => theme.palette.grey[600],
          }}
        >
          My Types
        </Typography>
        <Box>
          {types.map((type) => (
            <MenuItem
              key={type.id}
              onClick={() => {
                controller.lastSelectedType = type
                setPopoverResult(type)
              }}
              sx={{ py: 0.5 }}
            >
              {type.name}
            </MenuItem>
          ))}
        </Box>
      </Box>
    </>
  )
}
